<div id="sidebar" class="sidebar py-3 bg-light" [ngClass]="{collapsed: leftNavbarService.isCollapsed()}">
  <ul class="nav flex-column main-menu">
    <li *isGranted="['HOMEPAGE_VIEW']" class="nav-item">
      <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
         class="nav-link d-flex align-items-center"><i
        class="bi bi-house-fill me-2"></i><span>Home</span></a>
    </li>

    <li *isAnyGranted="['ACTIVITY_VIEW', 'PARTNER_VIEW']" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/partners')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-partners" role="button" aria-expanded="false"
         aria-controls="submenu-promotion-tools">
        <i class="bi bi-megaphone-fill"></i><span>Partners</span>
      </a>

      <div class="collapse" id="submenu-partners">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['ACTIVITY_VIEW']">
            <a routerLink="/partners/activity" routerLinkActive="active" class="nav-link">Activity</a>
          </li>
          <li class="nav-item" *isGranted="['PARTNER_VIEW']">
            <a routerLink="/partners" routerLinkActive="active" class="nav-link">Partners</a>
          </li>
        </ul>
      </div>
    </li>

    <li class="nav-item" *isGranted="['STATISTICS_VIEW']">
      <a [ngClass]="getActiveMenuClass('/stats')"
         class="nav-link dropdown-toggle d-flex align-items-center"
         data-bs-toggle="collapse"
         href="#stats" role="button" aria-expanded="false"
         aria-controls="stats">
        <i class="bi bi-pie-chart-fill me-2"></i><span>Stats</span>
      </a>

      <div class="collapse" id="stats">
        <ul class="nav flex-column ms-3">
          <!--          <li class="nav-item"><a href="globalstatistics.html" class="nav-link">Global statistics</a></li>-->
          <li class="nav-item">
            <a routerLink="/stats/detailed" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Detailed statistics</a></li>
          <li class="nav-item">
            <a routerLink="/stats/hourly" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Hourly statistics</a></li>
          <li class="nav-item">
            <a routerLink="/stats/funnels" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Funnel statistics</a></li>
          <li class="nav-item">
            <a routerLink="/stats/roi" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">ROI statistics</a></li>
          <!--          <li class="nav-item"><a href="roistatistics.html" class="nav-link">ROI statistics</a></li>-->
          <!--          <li class="nav-item"><a href="arpustatistics.html" class="nav-link">ARPU statistics</a></li>-->
        </ul>
      </div>
    </li>

    <li *isAnyGranted="['LANDING_PAGE_VIEW','STATIC_PAGE_VIEW','WIDGET_VIEW','FUNNEL_VIEW','REDIRECT_RULE_VIEW']" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/promotion-tools')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-promotion-tools" role="button" aria-expanded="false"
         aria-controls="submenu-promotion-tools"><i class="bi bi-megaphone-fill"></i><span>Promotion Tools</span>
      </a>

      <div class="collapse" id="submenu-promotion-tools">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['LANDING_PAGE_VIEW']"><a
            routerLink="/promotion-tools/landing-pages" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Promotion links</a></li>
          <li class="nav-item" *isGranted="['LANDING_PAGE_VIEW']"><a
            routerLink="/promotion-tools/landing-pages-pools" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Pool management</a></li>
          <li class="nav-item" *isGranted="['WIDGET_VIEW']"><a
            routerLink="/promotion-tools/cms/widgets" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Widgets</a></li>
          <li class="nav-item" *isGranted="['ASSET_VIEW']"><a
            routerLink="/promotion-tools/cms/content-library" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Content library</a></li>
          <li class="nav-item" *isGranted="['STATIC_PAGE_VIEW']"><a
            routerLink="/promotion-tools/cms/static-pages" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Page builder</a></li>
          <li class="nav-item" *isGranted="['FUNNEL_VIEW']"><a
            routerLink="/promotion-tools/cms/funnels" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Funnels</a></li>
          <li class="nav-item" *isGranted="['REDIRECT_RULE_VIEW']"><a
            routerLink="/promotion-tools/redirect-rules" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Redirect links</a></li>
        </ul>
      </div>
    </li>

    <li
      *isAnyGranted="[
        'ROLE_API_DEV',
        'ADVERTISER_VIEW',
        'PRODUCT_VIEW',
        'OFFER_VIEW',
        'GOAL_VIEW',
        'NEWS_VIEW',
        'IP_RULE_VIEW'
      ]"
      class="nav-item">
      <a [ngClass]="getActiveMenuClass('/configuration')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-configuration" role="button" aria-expanded="false"
         aria-controls="submenu-configuration"><i
        class="bi bi-bullseye me-2"></i><span>Configuration</span>
      </a>

      <div class="collapse" id="submenu-configuration">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['ADVERTISER_VIEW']">
            <a routerLink="/configuration/advertisers"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Advertisers</a>
          </li>
          <li class="nav-item" *isGranted="['PRODUCT_VIEW']">
            <a routerLink="/configuration/products"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Brands</a>
          </li>
          <li class="nav-item" *isGranted="['PRODUCT_PRIORITY_VIEW']">
            <a routerLink="/configuration/products-priority"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Brands priority list</a>
          </li>
          <li class="nav-item" *isGranted="['OFFER_VIEW']">
            <a routerLink="/configuration/offers"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Offers</a>
          </li>
          <li class="nav-item" *isGranted="['GOAL_VIEW']">
            <a routerLink="/configuration/goals"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Goals</a>
          </li>
          <li class="nav-item" *isGranted="['NEWS_VIEW']">
            <a routerLink="/configuration/news"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">GizmO News</a>
          </li>
          <li class="nav-item" *isGranted="['IP_RULE_VIEW']">
            <a routerLink="/configuration/ip-rules"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">IP rules</a>
          </li>
          <li class="nav-item" *isGranted="['STATIC_PAGE_VIEW']"><a
            routerLink="/configuration/domain" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact:true}" class="nav-link">Domain configuration</a></li>
        </ul>
      </div>
    </li>

    <li *isAnyGranted="['SITE_VIEW']" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/site')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-site" role="button" aria-expanded="false"
         aria-controls="submenu-site">
        <i class="bi bi-link-45deg me-2"></i><span>Sites</span>
      </a>

      <div class="collapse" id="submenu-site">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['SITE_VIEW']">
            <a routerLink="/site/sites"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Sites</a>
          </li>
          <li class="nav-item" *isGranted="['SITE_VIEW']">
            <a routerLink="/site/behavior-config"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Behavior Config</a>
          </li>
          <li class="nav-item" *isGranted="['BOT_RULE_VIEW']">
            <a routerLink="/site/bot-rules"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Bot rules</a>
          </li>
        </ul>
      </div>
    </li>

    <li *isAnyGranted="['TRANSLATION_VIEW', 'LANGUAGE_VIEW']" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/translation')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-translation" role="button" aria-expanded="false"
         aria-controls="submenu-translation">
        <i class="bi bi-translate me-2"></i><span>Translation</span>
      </a>

      <div class="collapse" id="submenu-translation">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['ROLE_API_DEV']">
            <a routerLink="/translation/translation-integration"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Translation Integration</a>
          </li>

          <li class="nav-item" *isGranted="['TRANSLATION_VIEW']">
            <a routerLink="/translation/translations"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Translations</a>
          </li>

          <li class="nav-item" *isGranted="['TRANSLATION_VIEW']">
            <a routerLink="/translation/bot-prompts" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Bot prompts</a>
          </li>

          <li class="nav-item" *isGranted="['LANGUAGE_VIEW']">
            <a routerLink="/translation/languages"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Languages</a>
          </li>

          <li class="nav-item" *isGranted="['LANGUAGE_VIEW']">
            <a routerLink="/translation/errors"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}"
               class="nav-link">Errors</a>
          </li>
        </ul>
      </div>
    </li>

    <li *isAnyGranted="['AFFILIATE_PAYMENT_VIEW']" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/accounting')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-accounting" role="button" aria-expanded="false"
         aria-controls="submenu-accounting">
        <i class="bi bi-person me-2"></i><span>Accounting</span>
      </a>

      <div class="collapse" id="submenu-accounting">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['AFFILIATE_PAYMENT_VIEW']">
            <a routerLink="/accounting/affiliate" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Affiliate payment</a>
          </li>
          <li class="nav-item" *isGranted="['AFFILIATE_PAYMENT_VIEW']">
            <a routerLink="/accounting/advertiser-report" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Advertiser report</a>
          </li>
          <li class="nav-item" *isGranted="['AFFILIATE_PAYMENT_VIEW']">
            <a routerLink="/accounting/affiliate-report" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact:true}" class="nav-link">Affiliate report</a>
          </li>
        </ul>
      </div>
    </li>

    <li *isAnyGranted="['USER_VIEW', 'USER_EVENT_VIEW']" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/users')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-users" role="button" aria-expanded="false" aria-controls="submenu-users"><i
        class="bi bi-person-lines-fill me-2"></i><span>Users</span>
      </a>

      <div class="collapse" id="submenu-users">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['USER_VIEW']">
            <a routerLink="/users/users"
               routerLinkActive="active"
               class="nav-link">Users</a>
          </li>
          <li class="nav-item" *isGranted="['USER_EVENT_VIEW']">
            <a routerLink="/users/activity-log"
               routerLinkActive="active" class="nav-link">Activity log</a>
          </li>
        </ul>
      </div>
    </li>

    <li *isAnyGranted="[
    'CLICK_VIEW',
    'CONVERSION_VIEW',
    'LEAD_VIEW',
    'COST_VIEW',
    'PREPING_TOOL_VIEW',
    'DECRYPT_TOOL_VIEW'
    ]" class="nav-item">
      <a [ngClass]="getActiveMenuClass('/system')"
         class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
         href="#submenu-system" role="button" aria-expanded="false" aria-controls="submenu-system"><i
        class="bi bi-gear-fill me-2"></i><span>System</span>
      </a>

      <div class="collapse" id="submenu-system">
        <ul class="nav flex-column ms-3">
          <li class="nav-item" *isGranted="['CLICK_VIEW']">
            <a routerLink="/system/click-log"
               routerLinkActive="active" class="nav-link">Click log</a>
          </li>
          <li class="nav-item" *isGranted="['LEAD_VIEW']">
            <a routerLink="/system/lead-log"
               routerLinkActive="active" class="nav-link">Lead log</a>
          </li>
          <li class="nav-item" *isGranted="['CONVERSION_VIEW']">
            <a routerLink="/system/conversion-log"
               routerLinkActive="active" class="nav-link">Conversion log</a>
          </li>
          <li class="nav-item" *isGranted="['CONVERSION_EVENT_VIEW']">
            <a routerLink="/system/conversion-event-log"
               routerLinkActive="active" class="nav-link">Conversion event log</a>
          </li>
          <li class="nav-item" *isGranted="['COST_VIEW']">
            <a routerLink="/system/cost-log"
               routerLinkActive="active" class="nav-link">Cost log</a>
          </li>
          <li class="nav-item" *isGranted="['ASYNC_COMMAND_VIEW']">
            <a routerLink="/system/async-command"
               routerLinkActive="active" class="nav-link">Async Tasks</a>
          </li>
          <li class="nav-item" *isGranted="['PREPING_TOOL_VIEW']">
            <a routerLink="/system/preping-tool"
               routerLinkActive="active" class="nav-link">Preping Tool</a>
          </li>
          <li class="nav-item" *isGranted="['DECRYPT_TOOL_VIEW']">
            <a routerLink="/system/decrypt-tool"
               routerLinkActive="active" class="nav-link">Decrypt Tool</a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <div class="sticky-bottom">
    <div class="version">{{ getVersion() }}</div>
  </div>
</div>
